export default {
    props: {
        tableInstance: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * @return {String}
         */
        tableName() {
            return this.tableInstance.name;
        },

        /**
         * @return {Array}
         */
        options() {
            return this.tableInstance.opts;
        },

        propOptions() {
            return this.tableInstance.options;
        },

        /**
         * @return {Array}
         */
        data() {
            return this.tableInstance.tableData;
        },

        /**
         * @return {String}
         */
        namespaced() {
            return `${this.tableName}_CHECKBOX`;
        },

        /**
         * @return {Integer}
         */
        totalSelected() {
            return this.$store.getters[`${this.namespaced}/totalSelected`];
        },

        /**
         * @return {Array}
         */
        getSelected() {
            return this.$store.getters[`${this.namespaced}/getSelected`];
        },

        /**
         * @return {Function}
         */
        isSelected() {
            return this.$store.getters[`${this.namespaced}/isSelected`];
        },

        /**
         * @return {Boolean}
         */
        hasSelected() {
            return this.$store.getters[`${this.namespaced}/hasSelected`];
        },

        /**
         * @return {Array}
         */
        uniqueKeys() {
            return this.data
                .filter(row => !this.options.checkboxDisableCallback(row))
                .map(row => row[this.options.uniqueKey]);
        },

        /**
         * @return {Boolean}
         */
        isAllRowSelected() {
            if (this.data.length < 1) {
                return false;
            }

            return this.uniqueKeys.every(x => this.getSelected.indexOf(x) > -1);
        },
    },

    methods: {
        toggleSelected(value) {
            this.$store.dispatch(`${this.namespaced}/toogleSelected`, value);
        },

        clearSelected() {
            this.$store.dispatch(`${this.namespaced}/clearSelected`);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mixins.js